import * as Actions from 'reducks/campaign/actions'
import { initialState } from 'reducks/reduxStore/initialState'

export const CampaignReducer = (state = initialState.campaign, action: any) => {
  switch (action.type) {
    case Actions.CONFIRM_CAMPAIGN:
      return {
        ...state,
        confirm: { ...action.payload },
      }
    case Actions.FETCH_CAMPAIGNS:
      return {
        ...state,
        confirm: initialState.campaign.confirm, // 詳細画面と登録画面を行き来する際の値をリセットするため
        campaigns: [...action.payload],
      }
    case Actions.INIT_CAMPAIGNS:
      return {
        ...initialState.campaign,
      }
    default:
      return state
  }
}
